export function StatusPill({ status, size = "md" }) {
  const map = {
    ok: { cls: "status-ok", label: "OK" },
    low: { cls: "status-low", label: "Faible" },
    critical: { cls: "status-critical", label: "Critique" },
    rupture: { cls: "status-rupture", label: "Rupture" },
  };
  const cfg = map[status] || map.ok;
  const sizeCls = size === "lg" ? "text-sm px-3 py-1.5" : "text-xs px-2.5 py-1";
  return (
    <span
      data-testid={`status-${status}`}
      className={`inline-flex items-center rounded-full font-semibold uppercase tracking-wide ${cfg.cls} ${sizeCls}`}
    >
      {cfg.label}
    </span>
  );
}
